import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { IDecline } from "@shared/lib/types/briefInfluencerV2";
import { BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY } from "../constants";
import { BriefService } from "../services/brief.service";

export function useDeclineBrand(briefId: string) {
  const {
    mutate: decline,
    isLoading: isDeclining,
    isSuccess: isDeclined,
  } = useMutation({
    mutationFn: (data: IDecline) =>
      BriefService.declineBrand(data).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: {},
    onSuccess: (c) => {
      c.invalidateQueries({
        queryKey: [...BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY, "facets", briefId],
      });

      c.invalidateQueries({
        queryKey: [...BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY],
      });
    },
  });

  return {
    decline,
    isDeclining,
    isDeclined,
  };
}
